import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClientHelperService } from 'src/app/api/http-client-helper.service';
import { SystemFileDownloadUrlResponse } from '../system-page/system-dpa-upload/system-dpa-upload.interface';

@Injectable({
	providedIn: 'root',
})
export class SystemFilesService {
	constructor(private httpClientHelper: HttpClientHelperService) {}

	getFileDownloadUrl(path: string): Observable<SystemFileDownloadUrlResponse> {
		return this.httpClientHelper.invokeGetAuth<SystemFileDownloadUrlResponse>(path);
	}
}
